import { Button as AntdButton } from 'antd';
import type { ComponentProps, ReactNode } from 'react';

import styles from './button.module.scss';

type AntdButtonProps = ComponentProps<typeof AntdButton>;

export type ButtonVariant =
  | 'highlight'
  | 'primary'
  | 'neutral'
  | 'secondary'
  | 'subtle'
  | 'outline';

export type ButtonProps = Omit<AntdButtonProps, 'type' | 'color' | 'variant' | 'icon'> & {
  /** Figma type: Highlight | Primary | Primary 2 | Secondary | Secondary 2 | Outline. */
  variant?: ButtonVariant;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
};

export function Button({
  variant = 'primary',
  startIcon,
  endIcon,
  className,
  children,
  ...rest
}: ButtonProps) {
  return (
    <AntdButton
      {...rest}
      className={[styles.button, styles[variant], className].filter(Boolean).join(' ')}
    >
      {startIcon ? <span className={styles.icon}>{startIcon}</span> : null}
      {children}
      {endIcon ? <span className={styles.icon}>{endIcon}</span> : null}
    </AntdButton>
  );
}
